import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-data-count-card',
  templateUrl: './dashboard-data-count-card.component.html',
  styleUrls: ['./dashboard-data-count-card.component.scss']
})
export class DashboardDataCountCardComponent {

      @Input() title: string = ''; // Title of the card
      @Input() totalCount: number = 0; // Total count value
      @Input() progressBarPercentage: number = 0; // Progress bar value
      @Input() activeLabel: string = 'Active'; // Label for the active data
      @Input() additionalTitle: string = 'Upcoming'; // Label for the active data
      @Input() activeCount: number = 0; // Count for the active data
      @Input() activeColor: string = '#9BE8FF'; // Color for the active indicator
      @Input() upcomingLabel: string = 'Upcoming'; // Label for the upcoming data
      @Input() upcomingCount: number = 0; // Count for the upcoming data
      @Input() upcomingColor: string = '#FDCD16'; // Color for the upcoming indicator
      @Input() remainingColor: string = '#e2e8f0';
      @Input() absentColor: string = '#FE828C';
      @Input() signedOutLabel: string = 'Signed-out'; // Label for the signed-out data
      @Input() signedOutCount: number = 0; // Count for the signed-out data
      @Input() signedOutColor: string = '#FCCF7A'; // Color for the signed-out indicator
      @Input() notMarkedLabel: string = 'Not Marked'; // Label for the not marked data
      @Input() notMarkedCount: number = 0; // Count for the not marked data
      @Input() notMarkedColor: string = '#7ADCFC'; // Color for the not marked indicator
      @Input() showSignedOut: boolean = false;
      @Input() showNotMarked: boolean = false;
      @Output() filterClick = new EventEmitter<any>();




      ngOnInit() {
        this.setProgressBarColor();
    }

    setProgressBarColor() {
        if (this.additionalTitle === 'Upcoming') {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#FDCD16'
            ); // Yellow
            this.upcomingColor = '#FDCD16';
        } else {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#FE828C'
            ); // Red
            this.upcomingColor = '#FE828C';

        }        
        if (this.upcomingLabel === 'Absent') {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#FE828C'
            ); // Red
            this.upcomingColor = '#FE828C';
        }
        if (this.additionalTitle === 'Signed-out') {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#FCCF7A'
            ); // Red
            this.upcomingColor = '#FCCF7A';
        }
        if (this.additionalTitle === 'Not Marked') {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#7ADCFC'
            ); // Red
            this.upcomingColor = '#7ADCFC';
        }
    }

    get activeProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.activeCount, this.totalCount) : 0;
    }

    get upcomingProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.upcomingCount, this.totalCount) : 0;
    }
    get signedOutProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.signedOutCount, this.totalCount) : 0;
    }

    get notMarkedProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.notMarkedCount, this.totalCount) : 0;
    }

    get remainingProgressPercentage(): number {
        if (this.totalCount === 0) {
            return 100; // Default to 100% gray when there are no students
        }
        const allocatedCount = (this.activeCount || 0) + (this.upcomingCount || 0) + (this.signedOutCount || 0) + (this.notMarkedCount || 0);
        const remainingCount = Math.max(0, this.totalCount - allocatedCount);
        return this.calculateProgressPercentage(remainingCount, this.totalCount);
    }

    private calculateProgressPercentage(part: number, total: number): number {
        return total ? (part / total) * 100 : 0;
    }

    onFilterClick(filterName: string, filterType: string) {

        if(filterType=='Signed-in'){
            filterType='Present';
        }     
        this.filterClick.emit({
            filterName: filterName,
            filterType: filterType
        });
    }

}
